import { render } from "./OrderManager.vue?vue&type=template&id=c95f81da"
import script from "./OrderManager.vue?vue&type=script&lang=js"
export * from "./OrderManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__